import React from "react";

import styled from "styled-components/macro";

export function FnrOverlayTitle({ children, style }) {
  return <Wrapper style={style}>{children}</Wrapper>;
}

const Wrapper = styled.div`
  font-size: 24px;
  font-weight: 400;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #bec3c7;
  display: flex;
  align-items: center;
`;

export function FnrOverlayTitleIcon({ icon }) {
  return <TitleIcon className={"fa-" + icon} />;
}

const TitleIcon = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 12px;
`;
